export default "__VITE_ASSET__P3sz3As___"